// extracted by mini-css-extract-plugin
export var leftRightBackg = "style-module--leftRightBackg--97d4c";
export var lensProtection = "style-module--lens-protection--807fd";